<template>
  <v-sheet class="d-flex align-center" color="stripes-background">
    <t-container class="text-h5">
      <v-row>
        <v-col
          v-if="icon !== undefined && header !== undefined"
          class="d-flex align-center"
          md="6"
          cols="12"
        >
          <v-icon size="30">
            {{ icon }}
          </v-icon>
          <span class="mx-2 titleheader">
            {{ header }}
          </span>
        </v-col>
        <v-spacer />
        <slot name="input" />
      </v-row>
    </t-container>
  </v-sheet>
</template>

<script setup lang="ts">
interface Props {
  header?: string;
  icon?: string;
}

const { header, icon } = defineProps<Props>();

defineOptions({ name: "TSectionHeader" });
</script>

<style>
@media screen and (max-width: 350px) {
  .row .titleheader {
    font-size: 20px;
  }
}
</style>
